import * as ko from "knockout";
import {IMessageData} from "../../../index";

export class AbstractDerived {
    protected readonly messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    protected readonly isReady: KnockoutObservable<boolean | null> = ko.observable(null);
}